import { render, staticRenderFns } from "./ShopAddressComponent.vue?vue&type=template&id=2d47c93d"
import script from "./ShopAddressComponent.vue?vue&type=script&lang=js"
export * from "./ShopAddressComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopAddressComponent.vue?vue&type=style&index=0&id=2d47c93d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports